exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".wrapper--LJIl3{position:fixed;background:rgba(0,0,0,.5);top:0;right:0;left:0;bottom:0;z-index:9999}.section--2xtft{position:fixed;right:50%;top:50%;z-index:2;float:right;padding:24px;border-radius:3px;box-shadow:0 6px 20px 0 rgba(0,0,0,.2),0 2px 5px 0 rgba(0,0,0,.1);background-color:#fff;transform:translate(50%,-50%);text-align:center}.section--2xtft p{padding-bottom:10px}", ""]);

// Exports
exports.locals = {
	"wrapper": "wrapper--LJIl3",
	"section": "section--2xtft"
};